/* USER */
export const SET_MY_USER = "SET_MY_USER";
export const REQUEST_MY_USER = "REQUEST_MY_USER";
